module.exports = {
  messages: {
    CN: {
      ExBack: "返回",
      ExOverviewTitle: "还在 LinkedIn 上手动加好友、发消息吗？",
      ExSubCopy:
        "StrategyBrain 让您的整个 LinkedIn 招聘流程全自动运行——<strong>无论您招聘什么职位。</strong>",
      ExPainManualTitle: "😩 手动寻源的痛点",
      ExPainSBTitle: "✨ StrategyBrain 的优势",
      ExAnyIndustry: "任何职位：",
      ExAnyIndustryNote: "...您招聘的任何职位都可以",
      ExStep1Title:
        "从<strong>您的个人 LinkedIn</strong>自动寻源。零手动操作。",
      ExFlowAccountTitle: "您的个人 LinkedIn",
      ExFlowAccountStrong: "我们不提供账号",
      ExFlowAccountP: "候选人看到您真实、可信的个人资料。",
      ExFlowSourceTitle: "自动寻源",
      ExFlowSourceStrong: "100% 全自动 · 零手动操作",
      ExFlowSourceP: "无需再一个个搜索或发送好友请求。",
      ExFlowCustomersTitle: "240 位候选人",
      ExFlowCustomersP:
        "与您的空缺职位完美匹配<br />自动同步到您的招聘管道。",
      ExHint:
        "只需粘贴一个 LinkedIn 人才搜索链接 → 您的账号会自动完成所有寻源工作。",
      ExStep2Title:
        "让 AI 直接在<strong class=\"blue\">您的收件箱</strong>中与候选人互动并完成初步筛选。（可针对任何职位要求完全定制。）",
      ExChatCopy:
        "以下两段对话均由 AI 全自动完成——<strong>点击任意一段放大查看完整记录：</strong>",
      ExInYourLinkedIn: "在您的 LinkedIn 中",
      ExAccountNote: "您的账号（AI 发送）",
      ExClickEnlarge: "点击放大查看完整对话",
      ExFootnote:
        "↑ 工程、销售……任何岗位都可以这样处理。AI 并行跟进全部 240 位候选人——您只需在有结果时介入。",
      ExStep3Title: "自动筛选高意向候选人——您只接手有结果的",
      ExResultCopy:
        "在 240 人中，AI 已完成沟通并筛选出 <strong>8 位高意向候选人</strong>，随时可以约面试 ↓",
      ExMetricInterested: "已收到简历",
      ExMetricContact: "联系方式（电话 / WhatsApp）",
      ExResultNote:
        "简历和联系方式会自动整理在这里——其他人（未回复 / 不合适）会自动归档，您永远不用翻私信。",
      ExCtaCopy: "明白了？现在就用 30 秒为您的职位创建同样的招聘任务。",
      ExCtaButton: "创建我的招聘任务",
      ExModalClose: "关闭",
      ExProblem1Title: "零回报：",
      ExProblem1:
        "在 LinkedIn 上花费数小时招聘，却找不到一个感兴趣的候选人。",
      ExProblem2Title: "黑洞：",
      ExProblem2: "给候选人发送无数消息，却零回复。",
      ExProblem3Title: "预算流失：",
      ExProblem3:
        "LinkedIn Recruiter 太贵了。想知道如何用多个普通账号来提升效率？",
      ExProblem4Title: "永远在线：",
      ExProblem4: "下班后还要工作，只为维持候选人的热度。",
      ExBenefit1Title: "100% 全自动：",
      ExBenefit1: "自动批量寻源候选人并发送个性化私信，零手动操作。",
      ExBenefit2Title: "智能意向筛选：",
      ExBenefit2: "让 AI 主动筛选候选人意向，大幅减少您的日常工作。",
      ExBenefit3Title: "AI 团队规模化：",
      ExBenefit3:
        "无缝管理多个 LinkedIn 账号，打造虚拟招聘团队，成倍提升产出。",
      ExBenefit4Title: "24/7 全球互动：",
      ExBenefit4:
        "通过全天候即时回复和无缝多语言支持，让您的招聘管道持续运转。",
      ExIndustry1: "工程",
      ExIndustry2: "销售",
      ExIndustry3: "产品",
      ExIndustry4: "设计",
      ExIndustry5: "运营",
      ExIndustry6: "财务",
      ExIndustry7: "支持",
      ExIndustry8: "市场",
      ExChatFeature1: "全部在您自己的 LinkedIn 上",
      ExChatFeature2: "AI 自动多轮回复，解答并跟进",
      ExChatFeature3: "自动收集简历和联系方式",
      ExChatFeature4: "多语言支持",
      ExConv1Role: "销售总监",
      ExConv2Role: "财务经理",
      ExConvFooter1: "已获取简历 + 联系方式",
      ExConvFooter2: "已获取电话 + 简历",
      ExConv1Msg1:
        "你好 James，您在北美领导快消品销售 12 年的经历非常亮眼。我们正在招聘销售总监（远程 · 底薪 + 不封顶提成）。方便简短聊一下吗？",
      ExConv1Msg2: "你好，感谢联系。能多介绍一下公司和薪资待遇吗？",
      ExConv1Msg3:
        "当然——一个正在北美扩张的快速消费品品牌。您将组建区域团队，负责 2000 万美元的目标。底薪 13 万美元 + 提成，OTE 约 22 万美元。",
      ExConv1Msg4: "听起来不错。团队规模多大？我向谁汇报？",
      ExConv1Msg5:
        "团队 8 人，向销售副总裁汇报，市场与运营支持强大。方便发一下简历吗？我们招聘负责人想看看。",
      ExConv1Msg6: "📎 James_Carter_CV.pdf — 给您。",
      ExConv1Msg7:
        "收到，谢谢！哪个电话最方便我们副总裁联系您做简短介绍电话？",
      ExConv1Msg8: "+1 415-555-0182，下午（美东时间）最方便。",
      ExConv1Msg9:
        "完美——已收到您的简历和电话 ✅ 我们的销售副总裁会尽快联系您。",
      ExConv2Msg1:
        "你好 Sophia，您 9 年制造业财务经验——预算与控制——非常匹配。我们正在招聘财务经理（混合办公 - 伦敦）。想了解更多吗？",
      ExConv2Msg2: "你好，好的。这个职位负责什么？",
      ExConv2Msg3:
        "您将负责一个 5000 万英镑业务单元的月度结账、预算与预测，带领 4 人团队，薪资 7.5 万–9 万英镑 + 奖金，每周 2 天混合办公。",
      ExConv2Msg4: "这与我的背景非常匹配。有机会晋升财务总监吗？",
      ExConv2Msg5:
        "有的——现任财务总监约 18 个月后晋升，这个职位就是计划中的继任岗位。能分享一下简历吗？我可以帮您快速直达财务负责人。",
      ExConv2Msg6: "📎 Sophia_Bennett_CV.pdf — 现在附上。",
      ExConv2Msg7: "谢谢！用哪个邮箱或电话安排第一次通话最方便？",
      ExConv2Msg8: "sophia.b@•••.com，或 +44 7700 900482。",
      ExConv2Msg9:
        "已收到您的简历和联系方式 ✅ 我们的财务负责人会尽快与您联系。期待合作！",
      ExLead1Role: "高级前端工程师",
      ExLead2Role: "销售经理",
      ExLead3Role: "产品设计师",
      ExLead4Role: "财务分析师",
      ExLead5Role: "后端工程师",
      Resume: "简历",
      Phone: "电话",
    },
    US: {
      ExBack: "Back",
      ExOverviewTitle: "Still manually connecting and messaging on LinkedIn?",
      ExSubCopy:
        "StrategyBrain puts your entire LinkedIn recruiting workflow on autopilot—<strong>no matter the position you're hiring for.</strong>",
      ExPainManualTitle: "😩 The Pain of Manual Sourcing",
      ExPainSBTitle: "✨ The StrategyBrain Advantage",
      ExAnyIndustry: "Any role:",
      ExAnyIndustryNote: "...any position you hire for",
      ExStep1Title:
        "Auto-source from <strong>your personal LinkedIn</strong>. Zero manual effort.",
      ExFlowAccountTitle: "Your Personal LinkedIn",
      ExFlowAccountStrong: "We do not provide accounts",
      ExFlowAccountP: "Candidates see your real, authentic profile.",
      ExFlowSourceTitle: "Automated Sourcing",
      ExFlowSourceStrong: "100% Autopilot · Zero Manual Effort",
      ExFlowSourceP: "No more searching or sending connection requests one by one.",
      ExFlowCustomersTitle: "240 Candidates",
      ExFlowCustomersP:
        "Perfectly matched to your open role<br />Automatically synced to your pipeline.",
      ExHint:
        "Just paste one LinkedIn people-search URL → your account handles all the sourcing automatically.",
      ExStep2Title:
        "Let AI engage and qualify candidates right from <strong class=\"blue\">your inbox</strong>. (Fully customizable for any job requisition.)",
      ExChatCopy:
        "The two conversations below are handled fully automatically by AI — <strong>click either one to enlarge the full transcript:</strong>",
      ExInYourLinkedIn: "Your LinkedIn",
      ExAccountNote: "Your account (sent by AI)",
      ExClickEnlarge: "Click to enlarge the full conversation",
      ExFootnote:
        "↑ Engineering, sales… any role can be handled this way. AI follows up with all 240 candidates in parallel — you only step in when there's a result.",
      ExStep3Title:
        "Auto-screens high-intent candidates — you only take over the ones with results",
      ExResultCopy:
        "Out of 240, AI has already chatted and surfaced <strong>8 high-intent candidates</strong>, ready for you to book interviews ↓",
      ExMetricInterested: "resumes received",
      ExMetricContact: "contact details (phone / WhatsApp)",
      ExResultNote:
        "Resumes and contact details are organized here automatically — everyone else (no reply / not a fit) is auto-archived, so you never dig through DMs.",
      ExCtaCopy:
        "Got it? Now create the same kind of hiring campaign for your own role in 30 seconds.",
      ExCtaButton: "Create my campaign",
      ExModalClose: "Close",
      ExProblem1Title: "Zero ROI:",
      ExProblem1:
        "Spending hours recruiting on LinkedIn without finding a single interested candidate.",
      ExProblem2Title: "The Black Hole:",
      ExProblem2: "Sending endless messages to candidates with zero response.",
      ExProblem3Title: "Budget Drain:",
      ExProblem3:
        "LinkedIn Recruiter is too expensive. Wondering how to use multiple standard accounts to scale your efficiency?",
      ExProblem4Title: "Always On:",
      ExProblem4: "Working after hours just to keep candidates warm.",
      ExBenefit1Title: "100% Autopilot:",
      ExBenefit1:
        "Automatically source candidates in bulk and send personalized DMs with zero manual effort.",
      ExBenefit2Title: "Smart Intent Screening:",
      ExBenefit2:
        "Let AI proactively qualify candidate interest, drastically reducing your daily workload.",
      ExBenefit3Title: "Scale With AI Teams:",
      ExBenefit3:
        "Seamlessly manage multiple LinkedIn accounts to build a virtual recruiting team and multiply your output.",
      ExBenefit4Title: "24/7 Global Engagement:",
      ExBenefit4:
        "Keep your pipeline moving with instant, round-the-clock replies and seamless multi-language support.",
      ExIndustry1: "Engineering",
      ExIndustry2: "Sales",
      ExIndustry3: "Product",
      ExIndustry4: "Design",
      ExIndustry5: "Operations",
      ExIndustry6: "Finance",
      ExIndustry7: "Support",
      ExIndustry8: "Marketing",
      ExChatFeature1: "All on your own LinkedIn",
      ExChatFeature2: "AI auto-replies across multiple turns, answering & following",
      ExChatFeature3: "Auto-collects resume + contact details",
      ExChatFeature4: "Multilingual",
      ExConv1Role: "Sales Director",
      ExConv2Role: "Finance Manager",
      ExConvFooter1: "Resume + contact captured",
      ExConvFooter2: "Phone + resume captured",
      ExConv1Msg1:
        "Hi James, your 12 years leading FMCG sales across North America really stands out. We're hiring a Sales Director (remote · base + uncapped commission). Open to a quick chat?",
      ExConv1Msg2:
        "Hi, thanks for reaching out. Could you share more about the company and the package?",
      ExConv1Msg3:
        "Sure — a fast-growing consumer brand expanding in North America. You'd build the regional team and own a $20M target. Base $130k + commission, OTE ~$220k.",
      ExConv1Msg4: "Sounds solid. What's the team size and who would I report to?",
      ExConv1Msg5:
        "A team of 8, reporting to the VP of Sales, with strong marketing & ops support. Would you mind sharing your CV so our hiring lead can review?",
      ExConv1Msg6: "📎 James_Carter_CV.pdf — here you go.",
      ExConv1Msg7:
        "Got it, thank you! What's the best number for our VP to reach you for a short intro call?",
      ExConv1Msg8: "+1 415-555-0182, afternoons (EST) work best.",
      ExConv1Msg9:
        "Perfect — received your CV and number ✅ Our VP of Sales will reach out soon.",
      ExConv2Msg1:
        "Hi Sophia, your 9 years in manufacturing finance – budgeting & controlling — is a great match. We're hiring a Finance Manager (hybrid - London). Interested in hearing more?",
      ExConv2Msg2: "Hello, yes please. What does the role cover?",
      ExConv2Msg3:
        "You'd own monthly close, budgeting and forecasting for a £50M unit, leading a team of 4, £75k–90k + bonus, hybrid 2 days/week.",
      ExConv2Msg4:
        "That matches my background well. Is there a path to Finance Director?",
      ExConv2Msg5:
        "Yes — the current FD steps up in ~18 months and this is the planned successor role. Could you share your CV so I can fast-track you to our Head of Finance?",
      ExConv2Msg6: "📎 Sophia_Bennett_CV.pdf — attaching now.",
      ExConv2Msg7:
        "Thank you! What's the best email or number to set up the first call?",
      ExConv2Msg8: "sophia.b@•••.com, or +44 7700 900482.",
      ExConv2Msg9:
        "Received your CV and details ✅ Our Head of Finance will be in touch shortly. Looking forward to it!",
      ExLead1Role: "Senior Frontend Engineer",
      ExLead2Role: "Sales Manager",
      ExLead3Role: "Product Designer",
      ExLead4Role: "Financial Analyst",
      ExLead5Role: "Backend Engineer",
      Resume: "Resume",
      Phone: "Phone",
    },
    AR: {
      ExBack: "رجوع",
      ExOverviewTitle: "هل ما زلت تتواصل وتراسل المرشحين يدويًا على LinkedIn؟",
      ExSubCopy:
        "يجعل StrategyBrain سير عمل التوظيف بالكامل على LinkedIn تلقائيًا — <strong>مهما كان المنصب الذي توظف له.</strong>",
      ExPainManualTitle: "😩 ألم البحث اليدوي",
      ExPainSBTitle: "✨ ميزة StrategyBrain",
      ExAnyIndustry: "أي منصب:",
      ExAnyIndustryNote: "...أي منصب تقوم بالتوظيف له",
      ExStep1Title:
        "البحث التلقائي من <strong>حسابك الشخصي على LinkedIn</strong>. دون أي مجهود يدوي.",
      ExFlowAccountTitle: "حسابك الشخصي على LinkedIn",
      ExFlowAccountStrong: "لا نوفر حسابات",
      ExFlowAccountP: "يرى المرشحون ملفك الشخصي الحقيقي والموثوق.",
      ExFlowSourceTitle: "البحث التلقائي",
      ExFlowSourceStrong: "طيار آلي 100% · دون مجهود يدوي",
      ExFlowSourceP: "لا مزيد من البحث أو إرسال طلبات الاتصال واحدًا تلو الآخر.",
      ExFlowCustomersTitle: "240 مرشحًا",
      ExFlowCustomersP:
        "مطابقة تمامًا لمنصبك الشاغر<br />ومزامنة تلقائيًا مع خط التوظيف.",
      ExHint:
        "ما عليك سوى لصق رابط بحث واحد عن الأشخاص على LinkedIn ← وسيتولى حسابك جميع أعمال البحث تلقائيًا.",
      ExStep2Title:
        "دع الذكاء الاصطناعي يتفاعل مع المرشحين ويؤهلهم مباشرة من <strong class=\"blue\">صندوق الوارد</strong> الخاص بك. (قابل للتخصيص الكامل لأي متطلب وظيفي.)",
      ExChatCopy:
        "المحادثتان أدناه تتمان تلقائيًا بالكامل بواسطة الذكاء الاصطناعي — <strong>انقر على أي منهما لتكبير النص الكامل:</strong>",
      ExInYourLinkedIn: "في LinkedIn الخاص بك",
      ExAccountNote: "حسابك (مرسلة بواسطة الذكاء الاصطناعي)",
      ExClickEnlarge: "انقر لتكبير المحادثة كاملة",
      ExFootnote:
        "↑ الهندسة والمبيعات... يمكن التعامل مع أي منصب بهذه الطريقة. يتابع الذكاء الاصطناعي جميع المرشحين الـ 240 بالتوازي — ولا تتدخل إلا عند ظهور نتيجة.",
      ExStep3Title:
        "فرز تلقائي للمرشحين ذوي النية العالية — لا تتولى إلا من لديهم نتائج",
      ExResultCopy:
        "من بين 240، تواصل الذكاء الاصطناعي بالفعل وأظهر <strong>8 مرشحين ذوي نية عالية</strong>، جاهزين لحجز المقابلات ↓",
      ExMetricInterested: "سير ذاتية مستلمة",
      ExMetricContact: "بيانات الاتصال (هاتف / واتساب)",
      ExResultNote:
        "يتم تنظيم السير الذاتية وبيانات الاتصال هنا تلقائيًا — ويتم أرشفة الآخرين تلقائيًا (لا رد / غير مناسب)، فلن تبحث أبدًا في الرسائل.",
      ExCtaCopy:
        "فهمت؟ أنشئ الآن نفس نوع حملة التوظيف لمنصبك في 30 ثانية.",
      ExCtaButton: "أنشئ حملتي",
      ExModalClose: "إغلاق",
      ExProblem1Title: "عائد صفري:",
      ExProblem1:
        "قضاء ساعات في التوظيف على LinkedIn دون العثور على مرشح مهتم واحد.",
      ExProblem2Title: "الثقب الأسود:",
      ExProblem2: "إرسال رسائل لا نهاية لها للمرشحين دون أي استجابة.",
      ExProblem3Title: "استنزاف الميزانية:",
      ExProblem3:
        "LinkedIn Recruiter مكلف للغاية. تتساءل كيف تستخدم حسابات عادية متعددة لرفع كفاءتك؟",
      ExProblem4Title: "متصل دائمًا:",
      ExProblem4: "العمل بعد ساعات الدوام فقط للحفاظ على اهتمام المرشحين.",
      ExBenefit1Title: "طيار آلي 100%:",
      ExBenefit1:
        "البحث التلقائي عن المرشحين بشكل جماعي وإرسال رسائل مخصصة دون أي مجهود يدوي.",
      ExBenefit2Title: "فرز ذكي للنية:",
      ExBenefit2:
        "دع الذكاء الاصطناعي يؤهل اهتمام المرشحين بشكل استباقي، مما يقلل عبء عملك اليومي بشكل كبير.",
      ExBenefit3Title: "التوسع مع فرق الذكاء الاصطناعي:",
      ExBenefit3:
        "إدارة حسابات LinkedIn متعددة بسلاسة لبناء فريق توظيف افتراضي ومضاعفة إنتاجيتك.",
      ExBenefit4Title: "مشاركة عالمية على مدار الساعة:",
      ExBenefit4:
        "حافظ على تدفق خط التوظيف من خلال ردود فورية على مدار الساعة ودعم متعدد اللغات.",
      ExIndustry1: "الهندسة",
      ExIndustry2: "المبيعات",
      ExIndustry3: "المنتج",
      ExIndustry4: "التصميم",
      ExIndustry5: "العمليات",
      ExIndustry6: "المالية",
      ExIndustry7: "الدعم",
      ExIndustry8: "التسويق",
      ExChatFeature1: "كل ذلك على LinkedIn الخاص بك",
      ExChatFeature2: "يرد الذكاء الاصطناعي تلقائيًا عبر عدة جولات، يجيب ويتابع",
      ExChatFeature3: "جمع تلقائي للسيرة الذاتية + بيانات الاتصال",
      ExChatFeature4: "متعدد اللغات",
      ExConv1Role: "مدير مبيعات",
      ExConv2Role: "مديرة مالية",
      ExConvFooter1: "تم الحصول على السيرة الذاتية + بيانات الاتصال",
      ExConvFooter2: "تم الحصول على الهاتف + السيرة الذاتية",
      ExConv1Msg1:
        "مرحبًا James، إن خبرتك البالغة 12 عامًا في قيادة مبيعات السلع الاستهلاكية سريعة الدوران في أمريكا الشمالية مميزة حقًا. نوظف حاليًا مدير مبيعات (عن بُعد · راتب أساسي + عمولة غير محدودة). هل أنت منفتح على محادثة سريعة؟",
      ExConv1Msg2: "مرحبًا، شكرًا لتواصلك. هل يمكنك مشاركة المزيد عن الشركة والحزمة؟",
      ExConv1Msg3:
        "بالتأكيد — علامة تجارية استهلاكية سريعة النمو تتوسع في أمريكا الشمالية. ستبني الفريق الإقليمي وتتولى هدفًا بقيمة 20 مليون دولار. راتب أساسي 130 ألف دولار + عمولة، إجمالي الأرباح المتوقع حوالي 220 ألف دولار.",
      ExConv1Msg4: "يبدو رائعًا. ما حجم الفريق ولمن سأقدم التقارير؟",
      ExConv1Msg5:
        "فريق من 8 أشخاص، تقدم تقاريرك إلى نائب رئيس المبيعات، مع دعم قوي من التسويق والعمليات. هل يمكنك مشاركة سيرتك الذاتية ليراجعها مسؤول التوظيف؟",
      ExConv1Msg6: "📎 James_Carter_CV.pdf — تفضل.",
      ExConv1Msg7:
        "تم الاستلام، شكرًا! ما أفضل رقم للتواصل معك من نائب الرئيس لإجراء مكالمة تعريفية قصيرة؟",
      ExConv1Msg8: "+1 415-555-0182، فترات ما بعد الظهر (بتوقيت شرق أمريكا) هي الأنسب.",
      ExConv1Msg9:
        "ممتاز — استلمنا سيرتك الذاتية ورقمك ✅ سيتواصل معك نائب رئيس المبيعات قريبًا.",
      ExConv2Msg1:
        "مرحبًا Sophia، إن خبرتك البالغة 9 سنوات في المالية الصناعية – الميزانية والرقابة – تطابق ممتاز. نوظف حاليًا مديرة مالية (هجين - لندن). هل ترغبين في معرفة المزيد؟",
      ExConv2Msg2: "مرحبًا، نعم من فضلك. ماذا يغطي الدور؟",
      ExConv2Msg3:
        "ستتولين الإغلاق الشهري والميزانية والتنبؤ لوحدة بقيمة 50 مليون جنيه إسترليني، وتقودين فريقًا من 4 أشخاص، براتب 75–90 ألف جنيه إسترليني + مكافأة، عمل هجين يومين في الأسبوع.",
      ExConv2Msg4: "هذا يتوافق مع خلفيتي جيدًا. هل هناك مسار نحو منصب المدير المالي؟",
      ExConv2Msg5:
        "نعم — سيترقى المدير المالي الحالي خلال ~18 شهرًا وهذا هو الدور المخطط له كخليفة. هل يمكنك مشاركة سيرتك الذاتية لأسرّع تقديمك إلى رئيس الشؤون المالية؟",
      ExConv2Msg6: "📎 Sophia_Bennett_CV.pdf — أرفقه الآن.",
      ExConv2Msg7: "شكرًا لك! ما أفضل بريد إلكتروني أو رقم لترتيب المكالمة الأولى؟",
      ExConv2Msg8: "sophia.b@•••.com، أو +44 7700 900482.",
      ExConv2Msg9:
        "استلمنا سيرتك الذاتية وبياناتك ✅ سيتواصل معك رئيس الشؤون المالية قريبًا. نتطلع إلى ذلك!",
      ExLead1Role: "مهندس واجهات أمامية أول",
      ExLead2Role: "مدير مبيعات",
      ExLead3Role: "مصممة منتجات",
      ExLead4Role: "محلل مالي",
      ExLead5Role: "مهندس خلفية",
      Resume: "السيرة الذاتية",
      Phone: "الهاتف",
    },
  },
};
